import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EvaluatorService } from 'src/app/core/services/evaluator.service';
import { ToastNotificationService } from 'src/app/core/services/toast-notification.service';

@Component({
  selector: 'app-evaluator-verify-email',
  templateUrl: './evaluator-verify-email.component.html',
  styleUrls: ['./evaluator-verify-email.component.scss']
})
export class EvaluatorVerifyEmailComponent implements OnInit {
  isVerified
  email: string
  message: string
  isSuccess: boolean
  isLoading: boolean 

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private evaluatorService: EvaluatorService,
    private notif: ToastNotificationService
  ) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.route.queryParams.subscribe(params => {
      this.isVerified = params['token'];
      this.email = params['email'];
      const body = {
        email: this.email,
        token: this.isVerified
      }
      this.evaluatorService.evaluatorVerify(body).subscribe((res) => {
        this.isLoading = false;
        this.isSuccess = true
        this.message = res.message;
        this.notif.openSuccess(this.message);
      }, err => {
        this.isLoading = false;
        this.isSuccess = false
        this.message = err.error.message;
        this.notif.openError(err.error.message);
      })
    });
  }

}
